import { render, staticRenderFns } from "./mgmtMenu.vue?vue&type=template&id=4080ce9a&lang=html"
import script from "./mgmtMenu.vue?vue&type=script&lang=js"
export * from "./mgmtMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports